import React from 'react'

import { arrayOf, number, shape, string } from 'prop-types'

import SignInModalHost from 'Pods/Shared/AiLanding/SignInModalHost/SignInModalHost'
import LinkedPagination from 'Pods/Shared/LinkedPagination/LinkedPagination'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

import Card from './Components/Card/Card'

const EAGER_IMAGE_COUNT = 3

function AiGeneratorHub({
  locale = 'en',
  title = '',
  items = EMPTY_ARRAY,
  pagination = EMPTY_OBJECT,
}) {
  return (
    <div className="ai-generator-hub">
      <div className="ai-generator-hub__container">
        <h1 className="ai-generator-hub__title cgt-heading-600">{title}</h1>
        <ul className="ai-generator-hub__grid">
          {items.map((item, index) => (
            <li key={item.href} className="ai-generator-hub__item">
              <Card
                href={item.href}
                heading={item.heading}
                imageSrc={item.imageSrc}
                imageWidth={item.imageWidth}
                imageHeight={item.imageHeight}
                eager={index < EAGER_IMAGE_COUNT}
              />
            </li>
          ))}
        </ul>
        {pagination.totalPages > 1 && (
          <LinkedPagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            currentPath={pagination.currentPath}
            labels={pagination.labels}
            className="ai-generator-hub__pagination"
          />
        )}
      </div>
      <SignInModalHost locale={locale} />
    </div>
  )
}

AiGeneratorHub.propTypes = {
  locale: string,
  title: string,
  items: arrayOf(shape({
    href: string.isRequired,
    heading: string.isRequired,
    imageSrc: string,
    imageWidth: number,
    imageHeight: number,
  })),
  pagination: shape({
    currentPage: number,
    totalPages: number,
    currentPath: string,
    labels: shape({ previous: string, next: string, jump: string }),
  }),
}

export default AiGeneratorHub
